import React from "react";
import { SideMenu, DateRangePicker } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import "./transaction-history.css";
import { useNavigate } from "react-router-dom";
let TransactionHistory = () => {
  const navigate = useNavigate();
  let TableData = [
    {
      date: "Jan 04, 2022",
      bankName: "HDFC bank",
      des: "Lorem ipsum dolor sit a...",
      courceName: "Lorem ipsum dolor sit a...",
      studentName: "Willow Anderson",
      country: "burnside",
      amount: "$2,000",
    },
    {
      date: "Jan 04, 2022",
      bankName: "HDFC bank",
      des: "Lorem ipsum dolor sit a...",
      courceName: "Lorem ipsum dolor sit a...",
      studentName: "Willow Anderson",
      country: "burnside",
      amount: "$2,000",
    },
    {
      date: "Jan 04, 2022",
      bankName: "HDFC bank",
      des: "Lorem ipsum dolor sit a...",
      courceName: "Lorem ipsum dolor sit a...",
      studentName: "Willow Anderson",
      country: "burnside",
      amount: "$2,000",
    },

    {
      date: "Jan 04, 2022",
      bankName: "HDFC bank",
      des: "Lorem ipsum dolor sit a...",
      courceName: "Lorem ipsum dolor sit a...",
      studentName: "Willow Anderson",
      country: "burnside",
      amount: "$2,000",
    },
    {
      date: "Jan 04, 2022",
      bankName: "HDFC bank",
      des: "Lorem ipsum dolor sit a...",
      courceName: "Lorem ipsum dolor sit a...",
      studentName: "Willow Anderson",
      country: "burnside",
      amount: "$2,000",
    },
    {
      date: "Jan 04, 2022",
      bankName: "HDFC bank",
      des: "Lorem ipsum dolor sit a...",
      courceName: "Lorem ipsum dolor sit a...",
      studentName: "Willow Anderson",
      country: "burnside",
      amount: "$2,000",
    },
    {
      date: "Jan 04, 2022",
      bankName: "HDFC bank",
      des: "Lorem ipsum dolor sit a...",
      courceName: "Lorem ipsum dolor sit a...",
      studentName: "Willow Anderson",
      country: "burnside",
      amount: "$2,000",
    },
    {
      date: "Jan 04, 2022",
      bankName: "HDFC bank",
      des: "Lorem ipsum dolor sit a...",
      courceName: "Lorem ipsum dolor sit a...",
      studentName: "Willow Anderson",
      country: "burnside",
      amount: "$2,000",
    },
  ];

  const ActionHandler = (e) => {
    if (e.target.value === "View") {
      navigate("/transaction-history/view");
    }
  };
  return (
    <SideMenu>
      <div className="page-container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}></Grid>
            <Grid item xl={2} lg={2} md={2} sm={6} xs={12}></Grid>
            <Grid item xl={2} lg={2} md={2} sm={6} xs={12}></Grid>
            <Grid item xl={2} lg={2} md={2} sm={12} xs={12}>
              <Button className="header-button" variant="text">
                <p className="page-header-button-text">Download</p>
              </Button>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={5} lg={5} md={5} sm={12} xs={12}>
              <div>
                <p className="header-input-heading">Search by title</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by title"
                />
              </div>
            </Grid>

            <Grid item xl={5} lg={5} md={5} sm={6} xs={12}>
              <DateRangePicker />
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={6} xs={12}>
              <Button className="header-apply-button" variant="text">
                <p className="header-apply-button-text">Apply</p>
              </Button>
            </Grid>
          </Grid>
        </Box>
        <br />
        <div className="table-container">
          <div className="table-data-container">
            <table>
              <thead>
              <tr>
                <th className="transaction-history-table-id-heading">ID</th>
                <th className="transaction-history-table-date-heading">Date</th>
                <th className="transaction-history-table-bank-name-heading">
                  Bank name
                </th>
                <th className="transaction-history-table-description-heading">
                  Discription
                </th>
                <th className="transaction-history-table-course-heading">
                  Cource name
                </th>
                <th className="transaction-history-table-student-name-heading">
                  student name
                </th>
                <th className="transaction-history-table-country-heading">
                  Country
                </th>
                <th className="transaction-history-table-amount-heading">
                  amount
                </th>
                <th className="transaction-history-table-status-heading"></th>
                <th className="transaction-history-table-action-heading"></th>
              </tr>
              </thead>
              {TableData.map((tableValue, tableIndex) => {
                return (
                  <tr key={tableIndex}>
                    <td className="table-id-data">{tableIndex + 1}</td>
                    <td className="table-data">{tableValue.date}</td>
                    <td className="table-data">{tableValue.bankName}</td>
                    <td className="table-data">{tableValue.des}</td>
                    <td className="table-data">{tableValue.courceName}</td>
                    <td className="table-data">{tableValue.studentName}</td>
                    <td className="table-data">{tableValue.country}</td>
                    <td className="table-data">{tableValue.amount}</td>
                    <td className="table-data">
                      <Button
                        className="transaction-history-table-status-button-text"
                        variant="text"
                      >
                        Paid
                      </Button>
                    </td>
                    <td className="table-data">
                      <select
                        className="table-action-dropdown"
                        onChange={ActionHandler}
                      >
                        <option value="">Action</option>
                        <option value="View">View</option>
                      </select>
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
          <div className="table-pagination-main">
            <Stack spacing={2}>
              <Pagination count={10} variant="outlined" shape="rounded" />
            </Stack>
          </div>
        </div>
      </div>
    </SideMenu>
  );
};
export default TransactionHistory;
